import React from "react";
import MUIButton from "@mui/material/Button";
import { getClassName } from "@sscs/utils";
import Tooltip from "../Tooltip/Tooltip";
import styles from "./button.module.scss";
const Button = ({ isFullWidth = false, isInline = false, tooltipTitle, children, size = "medium", color = "primary", variant = "contained", ...props }) => {
    const buttonComponent = (React.createElement(MUIButton, { ...props, "data-inline": isInline || undefined, fullWidth: isFullWidth, variant: variant, color: color, size: size }, children));
    if (!tooltipTitle)
        return buttonComponent;
    return (React.createElement(Tooltip, { title: tooltipTitle }, props.disabled ? (React.createElement("span", { className: getClassName(props.className, {
            [styles["full-width-tooltip-wrapper"]]: isFullWidth,
        }) }, buttonComponent)) : (buttonComponent)));
};
export default Button;
//# sourceMappingURL=Button.js.map